export default "__VITE_ASSET__cade2699__"